import React from 'react';

interface AuthorizedLayoutHeaderProps {
	background?: string;
	alignItems?: 'start' | 'end';
}

export function AuthorizedLayoutHeader({
	background = '#85c4ff',
	alignItems = 'end',
}: AuthorizedLayoutHeaderProps): React.ReactElement {
	const alignClass = alignItems === 'start' ? 'sm:items-start' : 'sm:items-end';

	return (
		<header
			className={`flex-none min-h-[69px] px-10 max-sm:px-4 py-5 max-sm:py-3 flex max-sm:items-start ${alignClass} justify-between`}
			style={{background}}
		>
			<div id="header-slot-left" className={'flex min-w-0 flex-1 flex-col items-stretch'} />

			<div id="header-slot-right" className={'flex shrink-0 items-start justify-end'} />
		</header>
	);
}
